import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Lottie from 'vue-lottie'
import 'vue-toast-notification/dist/theme-sugar.css';
import 'leaflet/dist/leaflet.css'
import VueToast from 'vue-toast-notification';
import Utils from './utils.js'
import Components from '@/components/base/index.js'
import VueApexCharts from 'vue-apexcharts';
import './plugins/empresaConfig'; // Importar el plugin
import '@mdi/font/css/materialdesignicons.css'
import NetworkMonitorPlugin from './plugins/networkMonitor'; // Plugin de monitoreo de red
import networkMonitor from './services/networkMonitor'; // Servicio de monitoreo
import axios from 'axios';
import { formatError, copyToClipboard } from './utils/errorClipboard';
import { tokenExpirado, redirectLoginExpirado } from './utils/jwt';
import interceptorCaseRequest from './services/interceptorCaseService';

Vue.prototype.$utils = Utils;
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(VueToast);
Vue.use(Components)
Vue.use(Viewer)
Vue.use(NetworkMonitorPlugin); // Instalar plugin de monitoreo de red

Vue.component('lottie',Lottie)
Vue.component('apexchart', VueApexCharts);
Vue.config.productionTip = false

axios.interceptors.request.use(interceptorCaseRequest);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // ─── Detección de 401 ─────────────────────────────────────────────────
    // Si es 401 + token expirado → cerrar sesión
    // Si es 401 + token vigente → solo mostrar toast (probable falta de permisos)
    // Si es 401 en endpoint de login → ignorar (no hay sesión que cerrar)
    if (error.response?.status === 401) {
      const esLogin = error.config?.url?.includes('/auth/');
      if (!esLogin && tokenExpirado()) {
        store.commit('logout');
        redirectLoginExpirado();
        return;
      }
    }

    const errorInfo = formatError(error);
    
    const toastMessage = errorInfo.response?.message 
      || errorInfo.response?.msg 
      || errorInfo.message;
    
    if (window.$toast) {
      window.$toast.error(toastMessage + ' - 📋 Tocá para copiar el error al portapapeles', {
        duration: 10000,
        dismissible: true,
        onClick: () => {
          copyToClipboard(errorInfo.fullText);
          window.$toast.success('📋 Error copiado al portapapeles', { duration: 2000 });
        }
      });
    }
    
    console.group('🔴 Error de API');
    console.error('Mensaje:', errorInfo.message);
    console.error('Código:', errorInfo.response?.status);
    console.error('--- Error completo ---');
    console.error(errorInfo.fullText);
    console.groupEnd();
    
    return Promise.reject(error);
  }
);

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// Inicializar el network monitor después de montar la app
// Esperar al siguiente tick para asegurar que $toast esté disponible
Vue.nextTick(() => {
  window.$toast = app.$toast;
  networkMonitor.initialize(app.$toast);
});

export default app;